import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/common.json'
import ja from './locales/ja/common.json'

const savedLang = localStorage.getItem('i18n-lang')
const browserLang = navigator.language.startsWith('ja') ? 'ja' : 'en'

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { common: en }, ja: { common: ja } },
    lng: savedLang ?? browserLang,
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
  })

export default i18n
